import React from 'react';
import SpecialPublicationPreAccessDetails from './SpecialPublicationPreAccessDetails';
import SpecialPublicationPreAccessFormContainer from './SpecialPublicationPreAccessFormContainer';
import styles from './SpecialPublicationPreAccessStyles.scss';

type SpecialPublicationPreAccessProps = {
  title: string;
  description: string;
  specialPublicationId: string;
  vanityName: string;
};

const SpecialPublicationPreAccess: React.FunctionComponent<SpecialPublicationPreAccessProps> = ({
  title,
  description,
  specialPublicationId,
  vanityName
}): React.ReactElement => {
  return (
    <div className={styles.container}>
      <SpecialPublicationPreAccessDetails title={title} description={description} />
      <SpecialPublicationPreAccessFormContainer
        specialPublicationId={specialPublicationId}
        vanityName={vanityName}
      />
    </div>
  );
};

export default SpecialPublicationPreAccess;
